export const TRANSLATIONS = {
    EN: {
        PAGE_TITLES: {
            COMPANY_DETAILS: 'Company details',
            MY_PRODUCTS: 'My products',
            DASHBOARD: 'Dashboard',
            ORGANIZATION: 'Organization',
            LOGIN: 'Login',
            TRANSACTION: 'Transaction',
            USER_DETAILS: 'User details',
            STARTING_COMPANY: 'Starting a company',
            LEADS: 'Leads',
            MY_ACCOUNT: 'My account',
            MY_INVOICES: 'My Invoices',
            ORGANIZATIONAL_RIGHTS: 'Organizational rights',
            EMPLOYEES: 'Employees',
            NOTIFICATIONS: 'Notifications',
            PAYMENT: 'Payment',
            LIQUIDATION: 'Liquidation',
            THANK_YOU: 'Thank you',
            TRANSACTIONS: 'Transactions',
            STATS: 'Stats',
            CONTACTS: 'Contacts',
            REFERRAL: 'Referral',
            SUBSCRIPTIONS: 'Subscriptions',
            PROCESS_LABELS: 'Process labels',
            REDIRECT: 'Redirect',
            SHOP_DEALS: 'Deals for entrepreneurs',
        },
    },
    NL: {
        PAGE_TITLES: {
            COMPANY_DETAILS: 'Bedrijfsgegevens',
            MY_PRODUCTS: 'Mijn producten',
            DASHBOARD: 'Dashboard',
            ORGANIZATION: 'Organisatie',
            LOGIN: 'Login',
            TRANSACTION: 'Transactie',
            USER_DETAILS: 'Gebruiker details',
            STARTING_COMPANY: 'Bedrijf oprichten',
            LEADS: 'Leads',
            MY_ACCOUNT: 'Mijn Account',
            MY_INVOICES: 'Mijn facturen',
            ORGANIZATIONAL_RIGHTS: 'Organisatierechten',
            EMPLOYEES: 'Werknemers',
            NOTIFICATIONS: 'Meldingen',
            PAYMENT: 'Betaling',
            LIQUIDATION: 'BV Opheffing',
            THANK_YOU: 'Bedankt',
            TRANSACTIONS: 'Transactions',
            STATS: 'Stats',
            CONTACTS: 'Contacten',
            REFERRAL: 'Referral',
            SUBSCRIPTIONS: 'Abonnementen',
            PROCESS_LABELS: 'Labels voor processen',
            REDIRECT: 'Omleiden',
            SHOP_DEALS: 'Ondernemersdeals',
        },
    },
};
